/* unplugin-vue-components disabled */import script from "./Review.vue?vue&type=script&setup=true&name=PaperReview&lang=js"
export * from "./Review.vue?vue&type=script&setup=true&name=PaperReview&lang=js"

import "./Review.vue?vue&type=style&index=0&id=278928cc&lang=scss"

const __exports__ = script;

export default __exports__